import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { useTranslation } from 'react-i18next'
import useModalStore from '@/store/useModalStore'
import Sucess from '@/assets/icons/Sucess'
import image from '@/assets/bg-finished.png'
import animation from '@/animations/animation-success.json'
import LottieAnimation from '../shared/LottieAnimation/LottieAnimation'

interface GenericModalProps {
  modalKey: string
  title: React.ReactNode
  description: React.ReactNode
  cancelButtonText?: string
  confirmButtonText?: string
  onConfirm?: () => void
  onCancel?: () => void
  icon?: React.ReactNode
  hideImage?: boolean
  hideCancelButton?: boolean
}

export function GenericModal({
  modalKey,
  title,
  description,
  cancelButtonText = 'Fechar',
  confirmButtonText = 'Confirmar',
  onConfirm,
  onCancel,
  icon = <Sucess />,
  hideImage = false,
  hideCancelButton = false,
}: GenericModalProps) {
  const { t } = useTranslation('common')
  const { modals, closeModal } = useModalStore()

  const handleClose = () => {
    onCancel?.()
    closeModal(modalKey)
  }

  const handleConfirm = () => {
    onConfirm?.()
    closeModal(modalKey)
  }

  return (
    <Dialog onOpenChange={handleClose} open={modals[modalKey]}>
      <DialogContent className="sm:max-w-[425px] rounded-lg w-[92%] p-0">
        {!hideImage && (
          <img
            className="relative w-full rounded-t-lg bg-cover bg-no-repeat"
            src={image}
            alt="Modal background"
          />
        )}
        {modalKey === 'user-onboarding-completed' && (
          <LottieAnimation data={animation} />
        )}

        <DialogHeader
          className={`px-6 relative ${hideImage ? 'mt-2 pt-6' : 'mt-6'}`}
        >
          {icon ? (
            <span className="mb-2">{icon}</span>
          ) : null}
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="whitespace-pre-line">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4 px-4">
          <DialogFooter className="flex gap-4">
            {!hideCancelButton && (
              <Button type="button" variant="outline" onClick={handleClose}>
                {t(cancelButtonText)}
              </Button>
            )}
            <Button type="button" onClick={handleConfirm}>
              {t(confirmButtonText)}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}